import { render } from "./Productions.vue?vue&type=template&id=aa771e20&scoped=true"
import script from "./Productions.vue?vue&type=script&lang=js"
export * from "./Productions.vue?vue&type=script&lang=js"

import "./Productions.vue?vue&type=style&index=0&id=aa771e20&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa771e20"]])

export default __exports__